// extracted by mini-css-extract-plugin
export default {"home":"homeStyles_home__JMoyK","card":"homeStyles_card__jMTw4","eyebrow":"homeStyles_eyebrow__otOU5","bio":"homeStyles_bio__szPo7"};